import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	manageParticipantsTimings: {
		id: 'eoc-on-call.tours.edit-rotation.manage-participants-timings',
		defaultMessage: 'Manage participants and timings',
		description: 'Title of edit rotation form spotlight.',
	},
	shiftParticipantsWillRotate: {
		id: 'eoc-on-call.tours.edit-rotation.shift-participants-will-rotate',
		defaultMessage:
			'Each people, team and escalation policy on this rotation is a shift participant. These will rotate with the time restrictions you provide.',
		description: 'Description of edit rotation form spotlight.',
	},
	previewScheduleChanges: {
		id: 'eoc-on-call.tours.edit-rotation.preview-schedule-changes',
		defaultMessage: 'Preview schedule changes before finalizing',
		description: 'Title of edit rotation schedule.',
	},
	previewAllowsToSeeChanges: {
		id: 'eoc-on-call.tours.edit-rotation.preview-allows-to-see-changes',
		defaultMessage:
			'The preview allows you to see how changes will impact the schedule, ensuring accurate coverage and avoiding conflicts.',
		description: 'Description of edit rotation schedule.',
	},
});
